export enum ActivityLogType {
  getGrounded = "get-grounded",
  breathingExercise = "breathing-exercise",
}
